module.exports = __webpack_public_path__ + "img/activities.00c0fc70.svg";